export const MARKETING_EVENT_COORDINATES = 'MARKETING_EVENT_COORDINATES';
export const CAMPAIGN_COORDINATES = 'CAMPAIGN_COORDINATES';
export const WEB_INTERACTIVE_COORDINATES = 'WEB_INTERACTIVE_COORDINATES';
export const AUTOMATION_PLATFORM_FLOW_COORDINATES = 'AUTOMATION_PLATFORM_FLOW_COORDINATES';